<div *ngIf="pageLoading" class="loader text-center">
	<img src="../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm"
	*ngIf="UserModuleAccess==='Full'">
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('vessel_name')}" id="vessel_name"
					formControlName="vessel_name" placeholder="">
				<label for="vessel_name">Name*</label>
			</div>
			<p *ngIf="showError('vessel_name')" class="text-danger">
				<span *ngIf="f.vessel_name.errors?.required">
					Required
				</span>
				<span *ngIf="f.vessel_name.errors?.incorrect">
					{{customError.vessel_name}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<ng-select appendTo="body" [items]="companyList" bindLabel="com_name" bindValue="id" [clearable]="true"
				[multiple]="false" id="co_id_id" formControlName="co_id_id" name="co_id_id" placeholder="Company*"
				[appearance]="'outline'">
			</ng-select>
			<p *ngIf="showError('co_id_id')" class="field-error">
				<mat-error *ngIf="f.co_id_id.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.co_id_id.errors?.incorrect">
					{{customError.co_id_id}}
				</mat-error>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('TypeOfVessel')}" id="TypeOfVessel"
					formControlName="TypeOfVessel" placeholder="">
				<label for="TypeOfVessel">Vessel Type*</label>
			</div>
			<p *ngIf="showError('TypeOfVessel')" class="text-danger">
				<span *ngIf="f.TypeOfVessel.errors?.required">
					Required
				</span>
				<span *ngIf="f.TypeOfVessel.errors?.incorrect">
					{{customError.TypeOfVessel}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('ImoNo')}" id="ImoNo"
					formControlName="ImoNo" placeholder="">
				<label for="ImoNo">IMO No.</label>
			</div>
			<p *ngIf="showError('ImoNo')" class="text-danger">
				<span *ngIf="f.ImoNo.errors?.required">
					Required
				</span>
				<span *ngIf="f.ImoNo.errors?.incorrect">
					{{customError.ImoNo}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('Route')}" id="Route"
					formControlName="Route" placeholder="">
				<label for="Route">Vessel Route</label>
			</div>
			<p *ngIf="showError('Route')" class="text-danger">
				<span *ngIf="f.Route.errors?.required">
					Required
				</span>
				<span *ngIf="f.Route.errors?.incorrect">
					{{customError.Route}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('CallSign')}" id="CallSign"
					formControlName="CallSign" placeholder="">
				<label for="CallSign">Call Sign</label>
			</div>
			<p *ngIf="showError('CallSign')" class="text-danger">
				<span *ngIf="f.CallSign.errors?.required">
					Required
				</span>
				<span *ngIf="f.CallSign.errors?.incorrect">
					{{customError.CallSign}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<!-- <button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button> -->
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>